'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectReportRecipientsStatistic = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectReportRecipientsStatistic, _Component);

  function ProjectReportRecipientsStatistic() {
    (0, _classCallCheck3.default)(this, ProjectReportRecipientsStatistic);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportRecipientsStatistic.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportRecipientsStatistic)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectReportRecipientsStatistic, [{
    key: 'getRecipientsProgressMessage',
    value: function getRecipientsProgressMessage(count, countAll) {
      return _react2.default.createElement(_reactI18next.Interpolate, {
        i18nKey: '{{count}} recipients / {{countAll}}',
        count: count,
        countAll: countAll
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          reportData = _props.reportData;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.ProjectReportProgressProperty, {
          title: t('Played'),
          message: this.getRecipientsProgressMessage(reportData.totalViews, reportData.totalRecipients),
          count: reportData.totalViews,
          countAll: reportData.totalRecipients
        }),
        _react2.default.createElement(_components.ProjectReportProgressProperty, {
          title: t('Downloads'),
          message: this.getRecipientsProgressMessage(reportData.totalDwn, reportData.totalPossibleDwn),
          count: reportData.totalDwn,
          countAll: reportData.totalPossibleDwn
        })
      );
    }
  }]);
  return ProjectReportRecipientsStatistic;
}(_react.Component), _class2.propTypes = {
  reportData: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = ProjectReportRecipientsStatistic;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReportRecipientsStatistic.js
// module id = 2059
// module chunks = 1